import PropTypes from 'prop-types';

import './validationWrapper.scss';

const findValidation = (validations, id) => {
  if (validations === null) return null;

  return validations.find(validation => validation.id === id);
};

const getPriceOfferId = (id) => {
  return parseInt(id, 10) + 1;
};

const ValidationWrapper = ({ children, validations, id }) => {
  ValidationWrapper.propTypes = {
    children: PropTypes.shape({}),
    validations: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string.isRequired,
  };

  const validation = findValidation(validations, id);

  if (!validation) {
    return (
      <>{ children }</>
    );
  }

  return (
    <div className="validation-wrapper">
      <div className="validation-wrapper--id">
        {getPriceOfferId(id)}
      </div>
      {children}
    </div>
  );
};

ValidationWrapper.defaultProps = {
  children: null,
  validations: null,
};

export default ValidationWrapper;
